/**
 * Main API entry point
 * Re-exports all domain-specific APIs for a unified interface.
 * Domain modules call the backend via HTTP `apiTransport` (POST /api RPC).
 */


import { propertiesApi } from './api/properties';
import { unitsApi } from './api/units';
import { tenantsApi } from './api/tenants';
import { accountingApi } from './api/accounting';
import { leasingApi } from './api/leasing';
import { maintenanceApi } from './api/maintenance';
import { vendorGamificationApi } from './api/vendorGamification';
import { coreDomainsApi } from './api/core-domains';
import { authApi } from './api/auth';
import { communicationsApi } from './api/communications';
import { communityApi } from './api/community';
import { ownersApi } from './api/owners';
import { investorsApi } from './api/investors';
import { paymentsApi } from './api/payments';
import { reportsApi } from './api/reports';
import { activityApi } from './api/activity';
import { notesApi } from './api/notes';
import { filesApi } from './api/files';
import { documentsApi } from './api/documents';
import { workflowsApi } from './api/workflows';
import { transactionsApi } from './api/transactions';
import { jobsApi } from './api/jobs';
import { investmentsApi } from './api/investments';
import { complianceApi } from './api/compliance';
import { paymentMethodsApi } from './api/paymentMethods';
import { settingsApi } from './api/settings';
import { integrationsApi } from './api/integrations';
import { bankingApi } from './api/banking';
import { portalApi } from './api/portal';
import { projectsApi } from './api/projects';
import { governanceApi } from './api/governance';
import { systemHealthApi } from './api/systemHealth';
import { relationshipsApi } from './api/relationships';
import { searchApi } from './api/search';

export const api = {
  dashboard: coreDomainsApi.dashboard,
  settings: coreDomainsApi.settings,
  marketing: coreDomainsApi.marketing,
  users: coreDomainsApi.users,
  tasks: coreDomainsApi.tasks,
  maintenance: maintenanceApi,
  vendorGamification: vendorGamificationApi,
  properties: propertiesApi,
  units: unitsApi,
  tenants: tenantsApi,
  investors: investorsApi.investors,
  investmentEntities: investorsApi.investmentEntities,
  entityInvestors: investorsApi.entityInvestors,
  portfolioItems: investorsApi.portfolioItems,
  owners: ownersApi,
  leasing: leasingApi,
  accounting: accountingApi,
  reports: reportsApi,
  auth: authApi,
  files: filesApi,
  documents: documentsApi,
  projects: projectsApi,
  communications: communicationsApi,
  community: communityApi,
  workflows: workflowsApi,
  payments: paymentsApi,
  transactions: transactionsApi,
  jobs: jobsApi,
  portal: portalApi,
  investments: investmentsApi,
  compliance: complianceApi,
  activity: activityApi,
  governance: governanceApi,
  systemHealth: systemHealthApi,
  relationships: relationshipsApi,
  search: searchApi,
  paymentMethods: paymentMethodsApi,
  ownerSettings: settingsApi.ownerSettings,
  tenantSettings: settingsApi.tenantSettings,
  vendorSettings: settingsApi.vendorSettings,
  investorSettings: settingsApi.investorSettings,
  integrationSettings: settingsApi.integrationSettings,
  integrations: integrationsApi,
  banking: bankingApi,
  notes: notesApi,
};

export default api;
